var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPooling = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8 4.667A1.333 1.333 0 1 0 8 2a1.333 1.333 0 0 0 0 2.667M6.667 3.333h-4m6.666 0h4M11.333 14H4.667M8 4.667V14M14.667 9.333a2 2 0 1 1-4 0m4 0-1.667-4h-.667l-1.666 4m4 0h-4M5.333 9.333a2 2 0 0 1-4 0m4 0-1.666-4H3l-1.667 4m4 0h-4"
})));
export { SvgPooling as ReactComponent };
export default __webpack_public_path__ + "static/media/Pooling.78770c6c.svg";